export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavTitle',
        _children: ['パートナー管理']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'パートナー管理',
        to: '/partner',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavItem',
        name: '代理店管理',
        to: '/agency',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['法人・求人管理']
      },
      {
        _name: 'CSidebarNavItem',
        name: '法人管理',
        to: '/organizations',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavItem',
        name: '求人管理',
        to: '/jobs',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'スタッフ管理',
        to: '/staffs',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['ニュース管理']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ニュース管理',
        to: '/news',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['ユーザー管理']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ユーザー管理',
        to: '/users',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavItem',
        name: '試験申し込み代行管理',
        to: '/payments',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['試験管理']
      },
      {
        _name: 'CSidebarNavItem',
        name: '試験問題管理',
        to: '/questions',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavItem',
        name: '試験業種管理',
        to: '/industries',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavItem',
        name: '試験日程管理',
        to: '/examinations',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavItem',
        name: '試験会場管理',
        to: '/places',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['学習用テキスト管理']
      },
      {
        _name: 'CSidebarNavItem',
        name: '学習用テキスト管理',
        to: '/learning_text',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['過去問題管理']
      },
      {
        _name: 'CSidebarNavItem',
        name: '過去問題管理',
        to: '/past_exam',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['その他']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ログアウト',
        to: '/logout',
        icon: 'cil-chart-pie'
      },

    ]
  }
]
